import { render, staticRenderFns } from "./physiology.vue?vue&type=template&id=a463e5f2&scoped=true&"
import script from "./physiology.vue?vue&type=script&lang=js&"
export * from "./physiology.vue?vue&type=script&lang=js&"
import style0 from "./physiology.vue?vue&type=style&index=0&id=a463e5f2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a463e5f2",
  null
  
)

export default component.exports